module.exports = __webpack_public_path__ + "VIPH14.png?a5556c6f60d2c96a1384d87d433c342d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH14.png
// module id = 86
// module chunks = 0